import ListTable from "common/ListTable";

const GarmentsTrackingTable = (props) => {
  const { total, loading, defaultCurrent, pageSize, current, onChange } = props;

  return (
    <>
      {/* {props.filter && (
        <CustomFilter
          showFilter={showFilter}
          handleFilter={handleFilter}
          tableData={props.dataSource}
          fetchTableData={null}
          filterName="buying_office"
        />
      )} */}
      <div className="table" style={{ marginTop: 10 }}>
        <ListTable
          loading={loading}
          pagination={{
            showSizeChanger: false,
            defaultPageSize: pageSize,
            current: current,
            onChange: onChange,
            defaultCurrent: defaultCurrent,
            total: total,
          }}
          columns={props.tableColumns}
          dataSource={props.dataSource}
          scroll={{ x: 1500 }}
          bordered
        />
      </div>
    </>
  );
};
export default GarmentsTrackingTable;
